import type { JSX } from 'react';
import { Button } from '../../../_components/Button.js';
import { SmileIcon } from '../../../_components/Icons.js';
import { GradientHeader } from '../../../_components/GradientHeader.js';
import type { FeedbackPalette, WidgetStep } from '../types.js';

interface ThanksViewProps {
  palette: FeedbackPalette;
  step: WidgetStep | undefined;
  title: string;
  body: string;
  onClose: () => void;
}

export function ThanksView({ palette, step, title, body, onClose }: ThanksViewProps): JSX.Element {
  return (
    <>
      <GradientHeader
        palette={palette}
        title={title}
        icon={<SmileIcon />}
        onClose={onClose}
        useGradient={palette.useGradient}
      />
      <div style={{ padding: '28px 24px', textAlign: 'center', color: palette.text }}>
        {step?.thanksImageUrl && (
          <img
            src={step.thanksImageUrl}
            alt=""
            style={{ maxWidth: 200, borderRadius: palette.radius, margin: '0 auto 16px', display: 'block' }}
          />
        )}
        <p style={{ color: palette.textMuted, margin: '0 0 24px', fontSize: 14 }}>{body}</p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          {step?.thanksCtaLabel && step?.thanksCtaUrl && (
            <a
              href={step.thanksCtaUrl}
              target="_top"
              rel="noopener noreferrer"
              style={{
                padding: '10px 18px',
                background: palette.primary,
                color: palette.onPrimary,
                borderRadius: palette.radius,
                textDecoration: 'none',
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              {step.thanksCtaLabel}
            </a>
          )}
          <Button palette={palette} onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </>
  );
}
